import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);
const routerPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch((error) => error);
};

const routes = [
  {
    path: "/",
    redirect: "/index",
  },
  {
    path: "/index",
    name: "Index",
    component: () => import("../views/Index.vue"),
  },
  {
    path: "/main",
    name: "Main",
    component: () => import("../views/Main.vue"),
    children: [
      {
        path: "/",
        redirect: "/newFiles",
        meta: {
          title: '众智云擎'
        }
      },
      {
        // 政策法规-地方版
        path: "/policyMate",
        name: "PolicyMate",
        component: () => import("../components/policyMate/index.vue"),
        meta: {
          title: '众智云擎'
        }
      },
      {
        // chat
        path: "/chatai",
        name: "chatai",
        component: () => import("../components/chat/chatAI.vue"),
        meta: {
          title: '众智云擎'
        }
      },
      {
        // 税务案例-地方版
        path: "/taxForm",
        name: "TaxForm",
        component: () => import("../components/taxForm/index.vue"),
        meta: {
          title: '众智云擎'
        }
      },
      {
        // 政策法规-全国版
        path: "/newFilesD",
        name: "NewFilesD",
        component: () => import("../components/newFiles/index_D.vue"),
        meta: {
          title: '众智云擎'
        }
      },
      {
        // 政策法规-地方版
        path: "/answer",
        name: "Answer",
        component: () => import("../components/answer/index.vue"),
        meta: {
          title: '众智云擎'
        }
      },
      {
        // 税务判例-地方版
        path: "/judgeCase",
        name: "JudgeCase",
        component: () => import("../components/judgeCase/index.vue"),
        meta: {
          title: '众智云擎'
        }
      },
      {
        // 税务案例-地方版
        path: "/taxCase",
        name: "TaxCase",
        component: () => import("../components/taxCase/index.vue"),
        meta: {
          title: '众智云擎'
        }
      },
      {
        // 税务案例-地方版
        path: "/expertAnswer",
        name: "ExpertAnswer",
        component: () => import("../components/expertAnswer/index.vue"),
        meta: {
          title: '众智云擎'
        }
      },
      {
        // 政策法规-地方版
        path: "/newFiles",
        name: "NewFiles",
        component: () => import("../components/newFiles/index.vue"),
        meta: {
          title: '众智云擎'
        }
      },
      {
        // 搜索引擎-全国版
        path: "/searchEngineD",
        name: "SearchEngineD",
        component: () => import("../components/searchEngine/index_D.vue"),
        meta: {
          title: '众智云擎'
        }
      },
      {
        // 搜索引擎-地方版
        path: "/searchEngine",
        name: "SearchEngine",
        component: () => import("../components/searchEngine/index.vue"),
        meta: {
          title: '众智云擎'
        }
      },
      {
        // 新搜索引擎-地方版
        path: "/newSearchEngine",
        name: "newSearchEngine",
        component: () => import("../components/newSearchEngine/index.vue"),
        meta: {
          title: '众智云擎'
        }
      },
      {
        // 智慧云端
        path: "/smartcloud",
        name: "Smartcloud",
        component: () => import("../components/smartcloud/index.vue"),
        meta: {
          title: '众智云擎'
        }
      },

      {
        // 网上商城
        path: "/onlineMall",
        name: "OnlineMall",
        component: () => import("../components/onlineMall/index.vue"),
        meta: {
          title: '众智云擎'
        }
      },
      {
        // 特别声明
        path: "/importantClause",
        name: "ImportantClause",
        component: () => import("../components/importantClause/index.vue"),
        meta: {
          title: '众智云擎'
        }
      },
      {
        // 账号中心
        path: "/personalCenter",
        name: "PersonalCenter",
        component: () => import("../components/personalCenter/index.vue"),
        meta: {
          title: '众智云擎'
        }
      },
      {
        // 操作手册
        path: "/usermanual",
        name: "Usermanual",
        component: () => import("../components/usermanual/index.vue"),
        meta: {
          title: '众智云擎'
        }
      },
      {
        // 演示视频
        path: "/videoList",
        name: "VideoList",
        component: () => import("../components/video/index.vue"),
        meta: {
          title: '众智云擎'
        }
      },
    ],
  },
  {
    // 政策法规-地方版
    path: "/exclusiveInfo",
    name: "ExclusiveInfo",
    component: () => import("../components/exclusiveInfo/index.vue"),
    meta: {
      title: '税收优惠政策'
    }
  },
  {
    // 政策法规-地方版
    path: "/speecher",
    name: "Speecher",
    component: () => import("../components/speecher/index.vue"),
  },

  {
    // 政策法规-地方版
    path: "/fileInfo",
    name: "FileInfo",
    component: () => import("../components/fileInfo/index.vue"),
  },
  {
    // 登录表单
    path: "/loginForm",
    name: "LoginForm",
    component: () => import("../components/common/loginForm/index.vue"),
  },
  {
    // 我的佣金popup
    path: "/promotion",
    name: "Promotion",
    component: () => import("../components/common/promotion/index.vue"),
  },
  {
    // 我的佣金popup
    path: "/myUsers",
    name: "MyUsers",
    component: () => import("../components/common/myUsers/index.vue"),
  },
  {
    // 我的会员页面
    path: "/myPrivilege",
    name: "MyPrivilege",
    component: () => import("../components/myPrivilege/index.vue"),
  },
  {
    // 我的订单页面
    path: "/myOrder",
    name: "MyOrder",
    component: () => import("../components/myOrder/index.vue"),
  },
  {
    // 续费页面
    path: "/xuFeiPage",
    name: "XuFeiPage",
    component: () => import("../components/xuFeiPage/index.vue"),
  },
  {
    // 我的发票页面
    path: "/myInvoice",
    name: "MyInvoice",
    component: () => import("../components/myInvoice/index.vue"),
  },
  {
    // 我的合同页面
    path: "/myContract",
    name: "MyContract",
    component: () => import("../components/myContract/index.vue"),
  },
  {
    // 视频播放页面
    path: "/playVideo",
    name: "PlayVideo",
    component: () => import("../components/video/playVideo.vue"),
  },
  {
    // 文件详情页面
    path: "/fileSharing",
    name: "FileSharing",
    component: () => import("../components/common/fileSharing/index.vue"),
  },
  {
    // 支付完成后回调页面
    path: "/orderPay",
    name: "OrderPay",
    component: () => import("../components/orderPay/index.vue"),
  },
  {
    // 虚拟
    path: "/agent",
    name: "Agent",
    component: () => import("../components/agent/index.vue"),
  },
  {
    // 扫码去哪
    path: "/agentgoto",
    name: "AgentGoTo",
    component: () => import("../components/agentgoto/index.vue"),
  },
  {
    // 微信登录
    path: "/oauth2",
    name: "Oauth2",
    component: () => import("../components/common/oauth2/index.vue"),
  },
  {
    // 网页端扫码登录
    path: "/scantologin",
    name: "Scantologin",
    component: () => import("../components/newcommon/scantologin/index.vue"),
  },
  {
    // 网页端扫码确认登录
    path: "/scantologinsure",
    name: "Scantologinsure",
    component: () =>
      import("../components/newcommon/scantologinsure/index.vue"),
  },
  {
    // 活动扫码
    path: "/activeCode",
    name: "ActiveCode",
    component: () => import("../components/newcommon/active/index.vue"),
  },
  {
    // 活动扫码确认
    path: "/activesure",
    name: "activesure",
    component: () => import("../components/newcommon/activesure/index.vue"),
  },
  {
    // 分享税法文件界面
    path: "/sharePage",
    name: "sharePage",
    component: () => import("../components/sharepage/index.vue"),
  },
  {
    // 分享界面
    path: "/shareregister",
    name: "shareregister",
    component: () => import("../components/shareregister/index.vue"),
  },

  {
    // 重定向到index页面
    path: "*",
    redirect: "/",
  },
];

const router = new VueRouter({
  mode: "history",
  // base: process.env.BASE_URL,
  routes,
});

export default router;
